import React, { useState } from 'react';

const SkeletonImage = ({
  src,
  alt = '',
  className = '',
  imgClassName = 'w-full h-full object-cover',
  style,
  imgStyle,
  icon = true,
  overlay,
  onDark = false,
  children,
}) => {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);

  const showSkeleton = !!src && !loaded && !failed;

  return (
    <div className={`relative overflow-hidden ${className}`} style={style}>
      {showSkeleton && (
        <div className={`absolute inset-0 z-10 ${onDark ? 'bg-white/15' : 'bg-slate-300/40'} backdrop-blur-[2px]`}>
          <div className="absolute inset-0 shimmer-animation" />
          {icon && (
            <div className="absolute inset-0 flex items-center justify-center">
              <svg
                className={`w-8 h-8 ${onDark ? 'text-white/60' : 'text-slate-400'}`}
                fill="none"
                stroke="currentColor"
                strokeWidth={1.5}
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
                />
              </svg>
            </div>
          )}
        </div>
      )}

      {failed && (
        <div className={`absolute inset-0 z-10 ${onDark ? 'bg-white/15' : 'bg-slate-300/40'} backdrop-blur-[2px] flex items-center justify-center`}>
          <svg
            className={`w-8 h-8 ${onDark ? 'text-white/60' : 'text-slate-400'}`}
            fill="none"
            stroke="currentColor"
            strokeWidth={1.5}
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
            />
          </svg>
        </div>
      )}

      {overlay && (
        <div className="absolute inset-0 z-[5] pointer-events-none">{overlay}</div>
      )}

      {src ? (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          onLoad={() => setLoaded(true)}
          onError={() => setFailed(true)}
          style={imgStyle}
          className={`relative z-0 transition-opacity duration-500 ${loaded ? 'opacity-100' : 'opacity-0'} ${imgClassName}`}
        />
      ) : (
        children
      )}
    </div>
  );
};

export default SkeletonImage;
